<script>
import { globalObservableStore, mutation } from '@/helpers/globalObservable'
import {
  killCountReferer,
  updateCountReferer
} from '@/helpers/httpInterceptors'
import { isEmpty } from 'lodash'
export default {
  name: 'modalTimer',
  data() {
    return {
      countDown: 59, //seg
      interval: null,
      showTimeIsUp: false,
      globalStore: globalObservableStore
    }
  },
  computed: {
    activeTimerModal() {
      return globalObservableStore.activeTimerModal
    }
  },
  watch: {
    globalStore: {
      handler() {
        if (globalObservableStore.activeTimerModal) {
          this._startCountDown()
        } else {
          this.countDown = 59
          this.interval = null
          this.showTimeIsUp = false
          clearInterval(this.interval)
        }
      },
      deep: true
    }
  },
  created() {
    this.unwatch = this.$store.watch(
      (state, getters) => getters.getJwt,
      newValue => {
        if (isEmpty(newValue)) {
          killCountReferer()
        }
      }
    )
  },
  methods: {
    _startCountDown() {
      this.interval = setInterval(() => {
        if (this.countDown > 0) {
          this.countDown--
        }
        if (this.countDown === 0) {
          clearInterval(this.interval)
          this.interval = null
          this.showTimeIsUp = true
          this.$store.dispatch('clearState')
          this.$router.push('login')
        }
      }, 1000)
    },
    closeModal() {
      mutation.setActiveTimerModal(false)
    },
    logoutFromModal() {
      this.$store.dispatch('clearState')
      this.$router.push('login')
      this.closeModal()
      clearInterval(this.interval)
    },
    continueSession() {
      updateCountReferer()
      this.closeModal()
      clearInterval(this.interval)
    }
  },
  beforeDestroy() {
    this.unwatch()
  }
}
</script>

<template>
  <div>
    <zt-modal :active="activeTimerModal" :show-button-close="false">
      <template slot="modal-header">
        <div class="p-3 w-full text-center">
          <h1 v-if="showTimeIsUp" class="mt-2 text-xl font-bold">
            {{ $t('message.modalTimer.title2') }}
          </h1>
          <h1 v-else class="mt-2 text-xl font-bold">{{ $t('message.modalTimer.title') }}</h1>
        </div>
      </template>
      <div class="p-8 text-center flex flex-col items-center justify-center">
        <div
          v-if="showTimeIsUp"
          class="flex flex-col items-center justify-center"
        >
          <p class="text-lg font-medium">
            {{ $t('message.modalTimer.body.textExpire') }}
          </p>
          <p class="text-lg font-medium mt-1">
            {{ $t('message.modalTimer.body.textExpire2') }}
          </p>
        </div>
        <div v-else class="flex flex-col items-center justify-center">
          <p class="text-lg font-medium">
            {{ $t('message.modalTimer.body.textCount') }}
          </p>
          <div class="flex items-end justify-center mt-2">
            <p class="text-6xl text-zt-primary-200">{{ countDown }}</p>
            <p class="mb-3 ml-2 text-zt-primary-200 font-bold">{{ $t('message.modalTimer.body.textSeg') }}</p>
          </div>
        </div>
      </div>
      <template slot="modal-footer">
        <div class="flex justify-center items-center p-4 w-full">
          <div v-if="showTimeIsUp">
            <zt-button @click="closeModal" class="mx-2">{{
              $t('message.modalTimer.buttons.close')
            }}</zt-button>
          </div>
          <div v-else class="flex justify-center w-full">
            <zt-button @click="logoutFromModal" class="mx-2" text>{{
              $t('message.modalTimer.buttons.closeSession')
            }}</zt-button>
            <zt-button @click="continueSession" class="mx-2">{{
              $t('message.modalTimer.buttons.continue')
            }}</zt-button>
          </div>
        </div>
      </template>
    </zt-modal>
  </div>
</template>

<style scoped lang="scss"></style>